<template>
    <!--snackbar-->
    <v-snackbar :value="showSnackbar" :timeout="3000" :top="true" @input="snackbarClose">

        <v-icon class="mr-1" :color="snackbar_color">{{snackbar_icon}}</v-icon>

        {{ snackbar_text }}

        <v-btn color="pink" flat @click.prevent="snackbarClose">
            {{ $t( 'reusable.close' ) }}
        </v-btn>

    </v-snackbar>

</template>

<script>
export default {
    name: 'Snackbar',
    props: [
        "color", "icon", "text", "show"
    ],
    data() {
        return {
            display: false
        }
    },
    computed: {
        showSnackbar: {
           get () {
                return this.show;
            },
            set(newValue){
                this.display = newValue;
            }
        },
        snackbar_text() {
            return this.text;
        },
        snackbar_icon() {
            return this.icon;
        },
        snackbar_color() {
            return this.color;
        },
    },
    methods: {
        snackbarClose() {

            let diasplay = !this.showSnackbar;

            this.$emit("update-snackbar", diasplay);

        }

    }

}
</script>
